import { pure } from 'recompose';
import PropTypes from 'prop-types';

const Body = () => null;

Body.propTypes = {
  children: PropTypes.node,
  cellOptions: PropTypes.func,
};

export default pure(Body);



// WEBPACK FOOTER //
// ./components/CourseViewTable/Body.jsx